/**
 * Scroll-reveal via IntersectionObserver. Staggers children marked
 * with [data-stagger-index] inside a [data-animate-group] ancestor.
 * No-op automatically when prefers-reduced-motion is set (CSS handles
 * that), but we also skip the observer entirely to save cycles.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = document.querySelectorAll('[data-animate]');
  if (!targets.length) return;

  if (reduceMotion || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('in-view'); });
    return;
  }

  targets.forEach(function (el) {
    var index = el.getAttribute('data-stagger-index');
    if (index !== null) el.style.setProperty('--stagger-index', index);
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  targets.forEach(function (el) { observer.observe(el); });

  /* Subtle parallax on hero media when enabled */
  document.querySelectorAll('.hero--parallax .hero-media').forEach(function (media) {
    var hero = media.closest('.hero');
    window.addEventListener('scroll', function () {
      var rect = hero.getBoundingClientRect();
      var progress = 1 - (rect.top / window.innerHeight);
      var translate = Math.min(Math.max(progress, 0), 1) * 40;
      media.style.transform = 'translateY(' + translate + 'px) scale(1.08)';
    }, { passive: true });
  });
})();
